export default "__VITE_ASSET__Joo66sqa__"